Namespace 'Customer.Dashboard'

class Customer.Dashboard.DashboardCustomerView extends Backbone.View
  id: 'customer-dashboard'
  className: 'show-filters'
  template: JST['backbone/templates/customer/dashboard/dashboard_customer']

  initialize: (@options = {}) ->
    @alreadyRendered = false
    @filtersShown = true
    @responseTemplates = new Customer.ResponseTemplateCollection.getCollection() # TODO: Esto no va aca
    @summaryViews = {}
    @socialAccounts = @options.socialAccounts
    @signatures = @options.signatures
    @customer_timeout_enabled = @options.customer_timeout_enabled
    @customerSession = @options.customer_session
    @customerSessionsRepository = @options.customer_sessions_repository
    @customerSessionsRepository.storeCurrentSession(@customerSession)
    window.addEventListener('beforeunload', (event) => @onBeforeUnload(event))

    @listenTo(Backbone, 'filter:selected', @onSelectFilter)
    @listenTo(Backbone, 'changed:selectedFilter', (filter) -> @trigger('updated:tab'))
    @filters = new Customer.NestedFilterCollection()
    @filterEventHandler ||=  new Customer.Dashboard.FilterEventHandler(@filters)
    @filterListView = new Customer.Filters.FilterListView({dashboardView: @, data: @options, filterEventHandler:  @filterEventHandler, filters: @filters })
    @customerSessionsChecker = new Customer.Sessions.CustomerSessionsChecker(@customerSession, @customer_timeout_enabled)
    @listenTo(@customerSessionsChecker, 'customer_session:about_to_expire', @sessionIsAboutToExpire)
    @listenTo(@customerSessionsChecker, 'customer_session:still_active', @sessionStillActive)

    @listenTo(@filterListView, 'filter:changed', @updateFilterWithoutTicket)
    @listenTo(@filterListView, 'filters:loaded', @onFiltersLoaded)
    @listenTo(@filterListView, 'filter:destroyed', @autoSelectFilter)

    @listenTo(Backbone, 'opened:ticket', @openTicket)

    @listenTo(Backbone, 'opened:relatedOpenedTickets', @openSummaryWithRelatedOpened)
    @listenTo(Backbone, 'opened:relatedClosedTickets', @openSummaryWithRelatedClosed)

    @welcomeView = new Customer.Dashboard.WelcomeView()

    @listenTo(Backbone, 'ui:blocked', @blockUI)
    @listenTo(Backbone, 'ui:unblocked', @unblockUI)

    @history = new Customer.Dashboard.History()

    @listenTo(Backbone, 'tickets:update_all:loading', @_loadingUpdateAllConversations)
    @listenTo(Backbone, 'tickets:update_all:countIds', @_loadingUpdateAllIdsCalculator)

    @listenTo(Backbone, 'interaction:go_to_case', @onGoToCase)

    @listenTo(Backbone, 'customerSession:keepAlive', @updateLastActivityTimestamp)
    @listenTo(Backbone, 'customerSession:updateBackEndLastAcivityTimestamp', @updateBackEndLastAcivityTimestamp)
    @listenTo(Backbone, 'operatorStatus:changed', @_operatorStatusChanged)

    Backbone.history.start()

  render: ->
    Visibility.change(@onVisiblilityChange)
    window.definitionsRepository = new Customer.DefinitionsRepository(@options.conversation_attributes_definitions)

    if @alreadyRendered then return @ else @alreadyRendered = true
    $(window).on('resize', @adjustHeight)
    @$el.html @template

    # --- Tab Manager ---
    @firstTabView = new Customer.Tabs.BasicTabView(tabbableView: @welcomeView, selected: true)

    listEl = $('ul#tabs')
    listEl.addClass('customer-tabs')
    containerEl = @$el.find('#tabs-column')
    principalContainer = $('div#principal-container')

    tabViews = [@firstTabView]

    @tabManagerView = new Customer.Tabs.TabManagerView(
      listEl: listEl,
      principalContainer: principalContainer,
      containerEl: containerEl,
      tabViews: tabViews,
      filterEventHandler: @filterEventHandler,
      socialAccounts: @options.socialAccounts,
      responseTemplates: @responseTemplates
      signatures: @signatures,
      enableNewCase: @options.enable_new_case,
      enabledEmailSocialAccounts: @options.enabled_outgoing_email_social_accounts,
      email_multi_threadkey_enabled: @options.email_multi_threadkey_enabled,
      default_email_subject_by_social_account_email: @options.default_email_subject_by_social_account_email
    )
    @listenTo(@tabManagerView, 'selected:tab', (summaryOrTicketView) =>
      summaryOrTicketView.onSelectTab(@)
      @adjustHeight()
    )

    @listenTo(@tabManagerView, 'refresh:tab', (summaryOrTicketView) =>
      summaryOrTicketView.onRefreshTab(@)
    )

    @filters.setTabManager(@tabManagerView)
    # ---

    @$el.find('#filters-column').html(@filterListView.render().el)
#    @$el.find('#filters-column').prepend(@newCaseView.render().el)

    @tabManagerView.render()

    if @history.conversation
      @fetchAndOpenTicketWithId(@history.conversation)

    @$ticketDetail = @$el.find('#detail')
    @adjustHeight()

    #rendering steals seconds from session so make it start from now:
    @_keepCustomerSessionAlive()
    @updateBackEndLastAcivityTimestamp()
    @_onDemandACD(@options.operator_available)

    @listenTo(Backbone, 'show:stale-notice', @adjustHeight)
    @_addMemoryLogger()
    @

  onBeforeUnload:(e) ->
    @customerSessionsRepository.removeCurrentSession(@customerSession)

  onVisiblilityChange: (event, state) =>
    @updateBackEndLastAcivityTimestamp() if state == 'visible'

  updateLastActivityTimestamp:=>
    now = new Date()
    @customerSession.lastActivityTime = now
    @customerSessionsRepository.updateSessionTimestamp(@customerSession, now)

  updateBackEndLastAcivityTimestamp:=>
    return if !@customer_timeout_enabled
    @customerSessionsChecker.updateSession(@customerSession, @customerSession.lastActivityTime)

  countersFindSpin:->
    @onRefreshStart()

  sessionIsAboutToExpire:(response)->
    @closeCustomerDashboardModals()
    @sessionAboutToExpireView.remove() if @sessionAboutToExpireView
    @sessionAboutToExpireView = new Customer.Dashboard.SessionAboutToExpireView(customerSession: @customerSession, timeTillExpiration: response.time_left_till_expiration)
    @$el.find('#session-about-to-expire-container').html(@sessionAboutToExpireView.render().el)
    @playNewInteractionSound()

  closeCustomerDashboardModals: () =>
    @filterListView.closeModals(false)
    @ticketView.closeModals() if @ticketView

  sessionStillActive:()->
    if @sessionAboutToExpireView
      @sessionAboutToExpireView.hide()
      @sessionAboutToExpireView.remove()

  countersFindStop:->
    @onRefreshFinish()

  fetchAndOpenTicketWithId: (ticketId, callback) =>
    ticketToOpen = new Customer.Ticket({id: ticketId}, @options.tags)
    ticketToOpen.fetch({
      silent: true
      global: false
      data: { page: 1 }
      success: (ticket) =>
        @openTicket(ticket)
        callback() if callback?
        Backbone.trigger('finished:open-ticket', ticket)
    })

  openSummaryWithRelatedOpened: (ticketId, relatedTicketsIds) =>
    filterName = "#{I18n.t('customer.dashboard.filters.names.related_opened')} #{ticketId}"
    @openSummaryWithTicketIds(filterName, relatedTicketsIds)

  openSummaryWithRelatedClosed: (ticketId, relatedTicketsIds) =>
    filterName = "#{I18n.t('customer.dashboard.filters.names.related_closed')} #{ticketId}"
    @openSummaryWithTicketIds(filterName, relatedTicketsIds)

  openSummaryWithTicketIds: (filterName, ticketIds) =>
    filter = new Customer.Filter(
      id: "transient_#{filterName}",
      name: filterName, global: false,
      is_transient: true
    )
    filter.set('query', $.extend({}, filter.get('query'), {id: ticketIds}))
    @onSelectFilter(filter, {refresh:false, summary_with_ticket_id: true})

  adjustHeight: =>
    @$el.css(
      'height',
      "calc(100vh - #{$('#main-header').outerHeight(true)}px)"
    )
    @filterListView.adjustHeight() if @filterListView
    @summaryView.adjustHeight() if @summaryView
    @ticketView.adjustHeight() if @ticketView
    Backbone.trigger('interactions:finished_loading')

  onFiltersLoaded: ->
    @autoSelectFilter()

  autoSelectFilter: (keepHistoryState=false) ->
    filters = @filterListView.filters
    filterToAutoselect = filters.where(id: @history.filter)[0]
    if filterToAutoselect
      filterToAutoselect.select()

  updateFilterWithoutTicket: (filter) ->
    if @selectedFilter && @selectedFilter.id == filter.id
      @history.setConversation(null).go()
      @onSelectFilter(@selectedFilter, {refresh:true})
    else
      @tabManagerView.discardView(@getNewSummaryView(filter))

  onSelectFilter: (filter, options={refresh:false}) ->
    @selectedFilter = filter
    @eventAggregator.trigger('customer:search', @selectedFilter) # This should be done from the model...
    @summaryView = @getNewSummaryView(@selectedFilter)
    @summaryView.resetLoadState()
    @listenTo(@summaryView, 'counters:find:spin', @countersFindSpin)
    @listenTo(@summaryView, 'counters:find:stop', @countersFindStop)
    tabView = new Customer.Tabs.TicketSummariesTabView(tabbableView: @summaryView, selected: true, summary_with_ticket_id: options.summary_with_ticket_id)
    @tabManagerView.changeToTab(tabView, options.refresh)
    @summaryView.newSearch() if @selectedFilter.getCallSummaryFirstTime()
    @adjustHeight()

  getNewSummaryView: (selectedFilter) ->
    result = @summaryViews[selectedFilter.id]
    if result
      return result
    else
       summary_view = new Customer.Dashboard.SummaryView
                          selectedFilter: selectedFilter
                          filters:@filterListView
                          tags: @options.tags
                          priorities: @options.priorities
                          filterEventHandler: @filterEventHandler
                          usersGroups: @options.users_groups
                          users: @options.users
                          conversation_attributes: @options.conversation_attributes
                          taxonomy_attributes: @options.taxonomy_attributes
       @summaryViews[selectedFilter.id] = summary_view
       return summary_view

  onGoToCase: (caseId, callback) ->
    @fetchAndOpenTicketWithId(caseId, callback)

  openTicket: (ticket) ->
    @eventAggregator.trigger('customer:openTicket')
    # @history.setConversation(ticket.id).go()
    @ticketView = @_newTicketView(ticket)
    # --- Tabs ---
    newTabView = new Customer.Tabs.TicketDetailsTabView({tabbableView: @ticketView, selected: true})
    @tabManagerView.changeToTab(newTabView)
    # ---
    @listenTo(@ticketView, 'ticket:tab:closeRequired', newTabView.onClickClose)
    @ticketView.adjustHeight() if @ticketView

  _newTicketView: (ticket) ->
    if(ticket.isWhatsapp())
      ticketView = new Customer.Ticket.WhatsappTicketView(_.extend({model: ticket}, @options))
    else
      ticketView = new Customer.Ticket.TicketView(_.extend({model: ticket}, @options))
    ticketView.startFetchingUpdates()
    @listenTo(ticketView, 'ticket:refresh:start', @onRefreshStart)
    @listenTo(ticketView, 'ticket:refresh:success', @onRefreshFinish)
    ticketView

  onRefreshStart: () ->
    @tabManagerView.startTabRefresh()

  onRefreshFinish: () ->
    @tabManagerView.finishTabRefresh()

  blockUI: ->
    @$el.addClass('processing')
    window.clearTimeout @blockTimeout
    @blockTimeout = window.setTimeout @unblockUI, 1000*15

  unblockUI: =>
    @$el.removeClass('processing')

  toggleFilters: ->
    @showFilters(!@filtersShown)

  showFilters: (show) =>
    @filtersShown = show
    if show
      @showColumn('filters')
    else
      @hideColumn('filters')

  hideColumn:(column_name) ->
    @$el.removeClass("show-#{column_name}").addClass("hide-#{column_name}")

  showColumn:(column_name) ->
    @$el.removeClass("hide-#{column_name}").addClass("show-#{column_name}")


  createResponseAttachment: ->
    @ticketView.createResponseAttachment() if @ticketView

  deleteResponseAttachment: =>
    @ticketView.destroyResponseAttachment() if @ticketView

  refreshSummary: ->
    @summaryView.newSearch() if @summaryView

  _loadingUpdateAllConversations: () =>
    showNotice I18n.t('self_service.massive_update.loading', email: Keepcon.current_user.email)

  _loadingUpdateAllIdsCalculator: () =>
    showNotice I18n.t('self_service.massive_update.ids.loading')

  newLoadingTicketView: (ticketId, ticketType) ->
    @playNewInteractionSound() unless @ticketTabView(ticketId) && @ticketTabView(ticketId).isSelected()
    return if @tabManagerView.tabIsLoaded(ticketId)
    loadingTicketView = new Customer.Ticket.LoadingTicketView({ticketId: ticketId, ticketType: ticketType, tags: @options.tags})
    @listenTo(loadingTicketView, 'ticket:finished-loading', @updateTabView)
    newTabView = new Customer.Tabs.TicketDetailsTabView({tabbableView: loadingTicketView, selected: false})
    @tabManagerView.addNewTab(newTabView)

  highlightTab: (ticketId, ticketType) ->
    @tabManagerView.highlightTab(ticketId, ticketType)

  updateTabView: (ticket, tabId) ->
    ticketView = @_newTicketView(ticket)
    @tabManagerView.updateTabView(ticketView, tabId)
    addedTabView = @ticketTabView(ticket.id)
    @listenTo(ticketView, 'ticket:tab:closeRequired', addedTabView.onClickClose) if addedTabView

  showIsTyping: (ticketId) =>
    _tabView = @tabManagerView.tabListView.tabView(ticketId)
    if _tabView && _tabView.tabbableView
      _tabView.tabbableView.showIsTyping();

  showWebchatFinalizedEvent: (ticketId, visibleEventDetail) =>
    ticket = @getTicket(ticketId)
    return if !ticket
    ticket_model = @tabManagerView.tabListView.tabView(ticketId).tabbableView.model
    ticket_model.visible_events().push(new Customer.VisibleEvent(visibleEventDetail))

  #TODO: This is astoundingly wrong but it has to be finished by today with the least possible amount of refactor
  addNewInteraction: (ticketId, data) ->
    ticket = @getTicket(ticketId)
    return if !ticket
    ticket.updateLockVersion(data.lock_version) if data.lock_version
    ticket.updateWithJson(data)

  updateTicketMetrics: (ticketId, data) ->
    ticket = @getTicket(ticketId)
    return if !ticket
    ticket.updateMetrics(data)

  getTicket: (ticketId) ->
    return if !@tabManagerView.tabIsLoaded(ticketId)
    @tabManagerView.tabListView.tabView(ticketId).tabbableView.model

  ticketTabView: (ticketId) ->
    return if !@tabManagerView.tabIsLoaded(ticketId)
    @tabManagerView.tabListView.tabView(ticketId)

  playNewInteractionSound: ->
    audio = new Audio(window.audio_path("new_interaction.wav"))
    audio.autoplay = true
    audio.load()
    setTimeout () =>
      audio.play().catch () =>
        console.log "Play sound failed"
    , 100

  getSumaryView: =>
   @summaryView

  getSelectedFilter: =>
    @selectedFilter

  _keepCustomerSessionAlive:->
    Backbone.trigger 'customerSession:keepAlive'

  _operatorStatusChanged: (newStatus)->
    @updateBackEndLastAcivityTimestamp()
    @_onDemandACD(newStatus.type_as_string == 'Available')

  _onDemandACD: (operator_available)->
    $.post('/customer/cases_distributors/assign', {}) if operator_available

  _addMemoryLogger: ->
    if Keepcon.currentAccount.id in Customer.memoryLoggingAccounts
      @_logMemory(true)
      setInterval(@_logMemory, Customer.refreshIntervals.memoryLogger)

  _logMemory: (firstIteration) ->
    memory = performance.memory.usedJSHeapSize / 1024 / 1024
    $.post(
      '/customer/browser_memory_usage/log',
      {used_memory: memory.toFixed(2), is_first_iteration: firstIteration == true}
    )
